import React, { useState, useRef, useEffect } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export const CheckboxSelect = ({ 
  options, 
  selectedOptions, 
  onChange, 
  placeholder,
  containerClassName = '',
  inputPlaceholder = 'Type account name to search',
  dropdownClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(search.toLowerCase())
  );

  const toggleOption = (option) => {
    const newSelectedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter(s => s !== option)
      : [...selectedOptions, option];
    onChange(newSelectedOptions);
  };

  const handleOpen = () => {
    setIsOpen(!isOpen);
  }

  const selectAll = (e) => {
    e.stopPropagation();
    const allValues = (filteredOptions || []).map((option) => option.value);
    onChange([...allValues]);
  };

  const selectNone = (e) => {
    e.stopPropagation();
    onChange([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      setSearch('');
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={`relative text-left w-64 ${containerClassName}`} ref={dropdownRef}>
        <div>
            <button
                type="button"
                className="inline-flex justify-between items-center w-full rounded-lg border border-gray-300 shadow-sm px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 h-10"
                onClick={handleOpen}
            >
            <span>{placeholder}</span>
                <ChevronDownIcon className="h-5 w-5 ml-2" aria-hidden="true" />
            </button>
        </div>
        <div className={`${isOpen ? "" : "hidden"} fixed mt-4 ${dropdownClassName || 'w-64'} rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 max-h-[80%] overflow-y-auto`}>
          <div className="py-1" role="menu" aria-orientation="vertical">
            <div className="sticky top-0 z-10 bg-white">
              <div className="px-3 py-2 text-sm text-gray-700 border-b border-gray-200 flex justify-center space-x-4">
                <button 
                  onClick={selectAll} 
                  className="text-blue-600 hover:underline"
                >
                  Select All
                </button>
                <button 
                  onClick={selectNone} 
                  className="text-blue-600 hover:underline"
                >
                  Select None
                </button>
              </div>
              <div className="px-2 py-1 border-b border-gray-200">
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={inputPlaceholder}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm"
                />
              </div>
            </div>
            {(filteredOptions || [])?.map((option, index) => (
                <button 
                    key={`${option.label}_${index}`} 
                    onClick={() => toggleOption(option.value)}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer w-full"
                >
                    <input
                        type="checkbox"
                        checked={selectedOptions.includes(option.value)}
                        className="mr-2"
                    />
                    <span className={`px-2 py-0.5 text-sm leading-5 font-medium rounded flex-1 text-left`}>
                        {option.label}
                    </span>
                </button>
            ))}
          </div>
        </div>
    </div>
  );
};
